import initialStore from '../initialStore';
import { BannersStore } from '../../types/banner';
import { Action } from '../../types/actions';

const bannersReducer = (currentState: BannersStore, action: Action) => {
  switch (action.type) {
  case 'ADD_BANNER':
    return {
      ...currentState,
      data: [...currentState.data, action.banner]
    };
  case 'REMOVE_BANNER':
    return {
      ...currentState,
      data: currentState.data.filter((banner) => banner.bannerType !== action.bannerType)
    };
  case 'CLEAR_BANNERS':
    return {
      ...currentState,
      data: []
    };
  case 'REMOVE_BANNER_DB':
    return {
      ...currentState,
      data: []
    };
  case 'REMOVE_BANNER_SUCCESS':
    return {
      ...currentState,
      data: action
    };
  case 'REMOVE_BANNER_ERROR':
    return {
      ...currentState,
      error: action.error
    };
  default:
    return currentState || initialStore.banners;
  }
};

export default bannersReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/banners.js